import { IEditRestaurantState } from './editRestaurantContext';
import { EditRestaurantActionTypes, TEditRestaurantAction } from './editRestaurantActions';

export const editRestaurantReducer = (
	state: IEditRestaurantState,
	action: TEditRestaurantAction,
): IEditRestaurantState => {
	switch (action.type) {
		case EditRestaurantActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
				fileIdForLauncherSettings: null,
			};
		case EditRestaurantActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditRestaurantActionTypes.SET_ALL_DATA:
			return {
				...state,
				restaurantId: action.payload.restaurantId,
				name: action.payload.name,
				shortName: action.payload.shortName,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				clientType: action.payload.clientType,
				IDSelectedCountry: action.payload.IDSelectedCountry,
				IDSelectedCity: action.payload.IDSelectedCity,
				address: action.payload.address,
				selectedCurrencySymbol: action.payload.selectedCurrencySymbol,
				masterPhoneNumber: action.payload.masterPhoneNumber,
				email: action.payload.email,
				code: action.payload.code,
				additionalApplications: action.payload.additionalApplications,
				vivaWalletIsv: action.payload.vivaWalletIsv,
				supplier: action.payload.supplier,
				isOpenPriceServiceCharge: action.payload.isOpenPriceServiceCharge,
				openPricePercent: action.payload.openPricePercent,
				priceType: action.payload.priceType,
				isUsedCustomerPriceType: action.payload.isUsedCustomerPriceType,
				loyalty: action.payload.loyalty,
				isUsedCustomerTips: action.payload.isUsedCustomerTips,
				tips0: action.payload.tips0,
				tips1: action.payload.tips1,
				tips2: action.payload.tips2,
				tips3: action.payload.tips3,
				defaultTips: action.payload.defaultTips,
				useKmTariff: action.payload.useKmTariff,
				tipsCommissionPercent: action.payload.tipsCommissionPercent,
				tipsCommissionMaxValue: action.payload.tipsCommissionMaxValue,
				isCharityEnabled: action.payload.isCharityEnabled,
				charityName: action.payload.charityName,
				charityLogoPath: action.payload.charityLogoPath,
				charityLogoFileId: action.payload.charityLogoFileId,
				charityAmount0: action.payload.charityAmount0,
				charityAmount1: action.payload.charityAmount1,
				charityAmount2: action.payload.charityAmount2,
				charityAmount3: action.payload.charityAmount3,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
				isShowCustomerLoyaltyProgramButtons: action.payload.isShowCustomerLoyaltyProgramButtons,
				isShowLoyaltyProgramButtons: action.payload.isShowLoyaltyProgramButtons,
				baseMcc: action.payload.baseMcc,
				mainMccCardBrand: action.payload.mainMccCardBrand,
				mainMccCardMcc: action.payload.mainMccCardMcc,
				mccCards: action.payload.mccCards,
				useCustomerMcc: action.payload.useCustomerMcc,
				downloadAppAndroidUrl: action.payload.downloadAppAndroidUrl,
				downloadAppIosUrl: action.payload.downloadAppIosUrl,
				IDDefaultLanguage: action.payload.IDDefaultLanguage,
				IDsLanguages: action.payload.IDsLanguages,
				restaurantLanguages: action.payload.restaurantLanguages,
				restrictionQrValue: action.payload.restrictionQrValue,
				usePosPhotos: action.payload.usePosPhotos,
				enableStopListJob: action.payload.enableStopListJob,
				useCustomerStopListSyncInterval: action.payload.useCustomerStopListSyncInterval,
				stopListSyncIntervalMinutes: action.payload.stopListSyncIntervalMinutes,
				updateOfTheLauncher: action.payload.updateOfTheLauncher,
				cardAcceptorId: action.payload.cardAcceptorId,
				cardAcceptorName: action.payload.cardAcceptorName,
				terminalId: action.payload.terminalId,
				vat: action.payload.vat,
				timeBlockChildAccess: action.payload.timeBlockChildAccess,
				IDPosSystem: action.payload.IDPosSystem,
				launcherSettingFilePath: action.payload.launcherSettingFilePath,
				generatedWatchCommandsLink: action.payload.generatedWatchCommandsLink,
				useMenuVersion: action.payload.useMenuVersion,
				useContentVersion: action.payload.useContentVersion,
				customerMenuVersion: action.payload.customerMenuVersion,
				customerContentVersion: action.payload.customerContentVersion,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
				restaurantContentVersion: action.payload.restaurantContentVersion,
				useTlsCertificate: action.payload.useTlsCertificate,
				tlsCertificateLevel: action.payload.tlsCertificateLevel,
				tlsCertificateName: action.payload.tlsCertificateName,
				tlsCertificateFilePath: action.payload.tlsCertificateFilePath,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				vatId: action.payload.vatId,
				kmVatId: action.payload.kmVatId,
				isActiveBpa: action.payload.isActiveBpa,
				bpaSetId: action.payload.bpaSetId,
				isApplicableForVat: action.payload.isApplicableForVat,
				sendDeviceUnavailabilityAlerts: action.payload.sendDeviceUnavailabilityAlerts,
				paymentTypeId: action.payload.paymentTypeId,
				extraPaymentTypes: action.payload.extraPaymentTypes,
			};
		case EditRestaurantActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditRestaurantActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditRestaurantActionTypes.CHANGE_SHORT_NAME:
			return {
				...state,
				shortName: action.payload.shortName,
			};
		case EditRestaurantActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditRestaurantActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDDefaultLanguage: null,
				IDsLanguages: [],
			};
		case EditRestaurantActionTypes.SET_CLIENT_TYPE:
			return {
				...state,
				clientType: action.payload.clientType,
			};
		case EditRestaurantActionTypes.SET_FETCHED_COUNTRIES:
			return {
				...state,
				fetchedCountries: action.payload.fetchedCountries,
			};
		case EditRestaurantActionTypes.SET_ID_COUNTRY:
			return {
				...state,
				IDSelectedCountry: action.payload.IDSelectedCountry,
				fetchedCities: [],
				IDSelectedCity: null,
			};
		case EditRestaurantActionTypes.SET_FETCHED_CITIES:
			return {
				...state,
				fetchedCities: action.payload.fetchedCities,
			};
		case EditRestaurantActionTypes.SET_ID_CITY:
			return {
				...state,
				IDSelectedCity: action.payload.IDSelectedCity,
			};
		case EditRestaurantActionTypes.CHANGE_ADDRESS:
			return {
				...state,
				address: action.payload.address,
			};
		case EditRestaurantActionTypes.SET_FETCHED_CURRENCIES:
			return {
				...state,
				fetchedCurrencies: action.payload.fetchedCurrencies,
			};
		case EditRestaurantActionTypes.SET_CURRENCY_SYMBOL:
			return {
				...state,
				selectedCurrencySymbol: action.payload.selectedCurrencySymbol,
			};
		case EditRestaurantActionTypes.CHANGE_MASTER_PHONE_NUMBER:
			return {
				...state,
				masterPhoneNumber: action.payload.masterPhoneNumber,
			};
		case EditRestaurantActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case EditRestaurantActionTypes.CHANGE_CODE:
			return {
				...state,
				code: action.payload.code,
			};
		case EditRestaurantActionTypes.SET_ADDITIONAL_APPLICATIONS:
			return {
				...state,
				additionalApplications: action.payload.additionalApplications,
				vivaWalletIsv: action.payload.vivaWalletIsv,
			};
		case EditRestaurantActionTypes.CHANGE_VIVA_WALLET_ISV:
			return {
				...state,
				vivaWalletIsv: action.payload.vivaWalletIsv,
			};
		case EditRestaurantActionTypes.CHANGE_SUPPLIER:
			return {
				...state,
				supplier: action.payload.supplier,
			};
		case EditRestaurantActionTypes.TOGGLE_IS_OPEN_PRICE_PERCENT:
			return {
				...state,
				isOpenPriceServiceCharge: !state.isOpenPriceServiceCharge,
				openPricePercent: null,
			};
		case EditRestaurantActionTypes.CHANGE_OPEN_PRICE_PERCENT:
			return {
				...state,
				openPricePercent: action.payload.openPricePercent,
			};
		case EditRestaurantActionTypes.CHANGE_PRICE_TYPE:
			return {
				...state,
				priceType: action.payload.priceType,
			};
		case EditRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_PRICE_TYPE:
			return {
				...state,
				isUsedCustomerPriceType: action.payload.isUsedCustomerPriceType,
				priceType: action.payload.priceType,
			};
		case EditRestaurantActionTypes.CHANGE_LOYALTY:
			return {
				...state,
				loyalty: action.payload.loyalty,
			};
		case EditRestaurantActionTypes.TOGGLE_IS_USED_CUSTOMER_TIPS:
			return {
				...state,
				isUsedCustomerTips: action.payload.isUsedCustomerTips,
				tips0: action.payload.tips0,
				tips1: action.payload.tips1,
				tips2: action.payload.tips2,
				tips3: action.payload.tips3,
				defaultTips: action.payload.defaultTips,
			};
		case EditRestaurantActionTypes.SET_TIPS_0:
			return {
				...state,
				tips0: action.payload.tips0,
			};
		case EditRestaurantActionTypes.SET_TIPS_1:
			return {
				...state,
				tips1: action.payload.tips1,
			};
		case EditRestaurantActionTypes.SET_TIPS_2:
			return {
				...state,
				tips2: action.payload.tips2,
			};
		case EditRestaurantActionTypes.SET_TIPS_3:
			return {
				...state,
				tips3: action.payload.tips3,
			};
		case EditRestaurantActionTypes.SET_DEFAULT_TIPS:
			return {
				...state,
				defaultTips: action.payload.defaultTips,
			};
		case EditRestaurantActionTypes.SET_TIPS_COMMISSION_PERCENT:
			return {
				...state,
				tipsCommissionPercent: action.payload.tipsCommissionPercent,
				tipsCommissionMaxValue: action.payload.tipsCommissionMaxValue,
			};
		case EditRestaurantActionTypes.SET_TIPS_COMMISSION_MAX_VALUE:
			return {
				...state,
				tipsCommissionMaxValue: action.payload.tipsCommissionMaxValue,
			};
		case EditRestaurantActionTypes.TOGGLE_IS_CHARITY_ENABLED:
			return {
				...state,
				isCharityEnabled: !state.isCharityEnabled,
			};
		case EditRestaurantActionTypes.CHANGE_CHARITY_NAME:
			return {
				...state,
				charityName: action.payload.charityName,
			};
		case EditRestaurantActionTypes.SET_CHARITY_LOGO_FILE:
			return {
				...state,
				charityLogoFileId: action.payload.charityLogoFileId,
				charityLogoPath: null,
			};
		case EditRestaurantActionTypes.SET_CHARITY_AMOUNT_0:
			return {
				...state,
				charityAmount0: action.payload.charityAmount0,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
			};
		case EditRestaurantActionTypes.SET_CHARITY_AMOUNT_1:
			return {
				...state,
				charityAmount1: action.payload.charityAmount1,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
			};
		case EditRestaurantActionTypes.SET_CHARITY_AMOUNT_2:
			return {
				...state,
				charityAmount2: action.payload.charityAmount2,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
			};
		case EditRestaurantActionTypes.SET_CHARITY_AMOUNT_3:
			return {
				...state,
				charityAmount3: action.payload.charityAmount3,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
			};
		case EditRestaurantActionTypes.SET_DEFAULT_CHARITY_AMOUNT_INDEX:
			return {
				...state,
				defaultCharityAmountIndex: action.payload.defaultCharityAmountIndex,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_KM_TARIFF:
			return {
				...state,
				useKmTariff: !state.useKmTariff,
			};
		case EditRestaurantActionTypes.TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS:
			return {
				...state,
				isShowLoyaltyProgramButtons: !state.isShowLoyaltyProgramButtons,
			};
		case EditRestaurantActionTypes.CHANGE_BASE_MCC:
			return {
				...state,
				baseMcc: action.payload.baseMcc,
			};
		case EditRestaurantActionTypes.ADD_MCC_CARD:
			return {
				...state,
				mccCards: action.payload.mccCards,
			};
		case EditRestaurantActionTypes.DELETE_MCC_CARD:
			return {
				...state,
				mccCards: action.payload.mccCards,
			};
		case EditRestaurantActionTypes.CHANGE_MAIN_MCC_CARD_BRAND:
			return {
				...state,
				mainMccCardBrand: action.payload.mainMccCardBrand,
			};
		case EditRestaurantActionTypes.CHANGE_MCC_CARD_BRAND:
			return {
				...state,
				mccCards: action.payload.mccCards,
			};
		case EditRestaurantActionTypes.CHANGE_MAIN_MCC_CARD_MCC:
			return {
				...state,
				mainMccCardMcc: action.payload.mainMccCardMcc,
			};
		case EditRestaurantActionTypes.CHANGE_MCC_CARD_MCC:
			return {
				...state,
				mccCards: action.payload.mccCards,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_CUSTOMER_MCC:
			return {
				...state,
				useCustomerMcc: !state.useCustomerMcc,
			};
		case EditRestaurantActionTypes.CHANGE_DOWNLOAD_APP_ANDROID_URL:
			return {
				...state,
				downloadAppAndroidUrl: action.payload.downloadAppAndroidUrl,
			};
		case EditRestaurantActionTypes.CHANGE_DOWNLOAD_APP_IOS_URL:
			return {
				...state,
				downloadAppIosUrl: action.payload.downloadAppIosUrl,
			};
		case EditRestaurantActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case EditRestaurantActionTypes.SET_ID_DEFAULT_LANGUAGE:
			return {
				...state,
				IDDefaultLanguage: action.payload.IDDefaultLanguage,
			};
		case EditRestaurantActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsLanguages: action.payload.IDsLanguages,
			};
		case EditRestaurantActionTypes.CHANGE_RESTRICTION_QR_VALUE:
			return {
				...state,
				restrictionQrValue: action.payload.restrictionQrValue,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_POS_PHOTOS:
			return {
				...state,
				usePosPhotos: !state.usePosPhotos,
			};
		case EditRestaurantActionTypes.TOGGLE_STOP_LIST_JOB:
			return {
				...state,
				enableStopListJob: !state.enableStopListJob,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_CUSTOMER_STOP_LIST_SYNC_INTERVAL:
			return {
				...state,
				useCustomerStopListSyncInterval: !state.useCustomerStopListSyncInterval,
			};
		case EditRestaurantActionTypes.CHANGE_STOP_LIST_SYNC_INTERVAL_MINUTES:
			return {
				...state,
				stopListSyncIntervalMinutes: action.payload.stopListSyncIntervalMinutes,
			};
		case EditRestaurantActionTypes.TOGGLE_UPDATE_OF_THE_LAUNCHER:
			return {
				...state,
				updateOfTheLauncher: !state.updateOfTheLauncher,
			};
		case EditRestaurantActionTypes.CHANGE_CARD_ACCEPTOR_ID:
			return {
				...state,
				cardAcceptorId: action.payload.cardAcceptorId,
			};
		case EditRestaurantActionTypes.CHANGE_CARD_ACCEPTOR_NAME:
			return {
				...state,
				cardAcceptorName: action.payload.cardAcceptorName,
			};
		case EditRestaurantActionTypes.CHANGE_TERMINAL_ID:
			return {
				...state,
				terminalId: action.payload.terminalId,
			};
		case EditRestaurantActionTypes.CHANGE_VAT:
			return {
				...state,
				vat: action.payload.vat,
			};
		case EditRestaurantActionTypes.CHANGE_TIME_BLOCK_CHILD_ACCESS:
			return {
				...state,
				timeBlockChildAccess: action.payload.timeBlockChildAccess,
			};
		case EditRestaurantActionTypes.SET_ID_POS_SYSTEM:
			return {
				...state,
				IDPosSystem: action.payload.IDPosSystem,
			};
		case EditRestaurantActionTypes.SET_FILE_ID_FOR_LAUNCHER_SETTINGS:
			return {
				...state,
				fileIdForLauncherSettings: action.payload.fileIdForLauncherSettings,
			};
		case EditRestaurantActionTypes.SET_FETCHED_ACQUIRERS:
			return {
				...state,
				fetchedAcquirers: action.payload.fetchedAcquirers,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_MENU_VERSION:
			return {
				...state,
				useMenuVersion: action.payload.useMenuVersion,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_CONTENT_VERSION:
			return {
				...state,
				useContentVersion: action.payload.useContentVersion,
				restaurantContentVersion: action.payload.restaurantContentVersion,
			};
		case EditRestaurantActionTypes.CHANGE_RESTAURANT_MENU_VERSION:
			return {
				...state,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
			};
		case EditRestaurantActionTypes.CHANGE_RESTAURANT_CONTENT_VERSION:
			return {
				...state,
				restaurantContentVersion: action.payload.restaurantContentVersion,
			};
		case EditRestaurantActionTypes.TOGGLE_USE_TLS_CERTIFICATE:
			return {
				...state,
				useTlsCertificate: !state.useTlsCertificate,
				tlsCertificateLevel: null,
				tlsCertificateName: null,
				tlsCertificateFilePath: null,
				tlsCertificateFileId: null,
				tlsCertificateFileHash: null,
			};
		case EditRestaurantActionTypes.SET_TLS_CERTIFICATE_LEVEL:
			return {
				...state,
				tlsCertificateLevel: action.payload.tlsCertificateLevel,
				tlsCertificateName: null,
				tlsCertificateFilePath: null,
				tlsCertificateFileId: null,
				tlsCertificateFileHash: null,
			};
		case EditRestaurantActionTypes.CHANGE_TLS_CERTIFICATE_NAME:
			return {
				...state,
				tlsCertificateName: action.payload.tlsCertificateName,
			};
		case EditRestaurantActionTypes.SET_TLS_CERTIFICATE_FILE:
			return {
				...state,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				tlsCertificateFileHash: action.payload.tlsCertificateFileHash,
				tlsCertificateFilePath: null,
			};
		case EditRestaurantActionTypes.CHANGE_VAT_ID:
			return {
				...state,
				vatId: action.payload.vatId,
			};
		case EditRestaurantActionTypes.CHANGE_KM_VAT_ID:
			return {
				...state,
				kmVatId: action.payload.kmVatId,
			};
		case EditRestaurantActionTypes.SET_BPA_SET_ID:
			return {
				...state,
				bpaSetId: action.payload.bpaSetId,
			};
		case EditRestaurantActionTypes.TOGGLE_APPLICABLE_FOR_VAT:
			return {
				...state,
				isApplicableForVat: !state.isApplicableForVat,
			};
		case EditRestaurantActionTypes.TOGGLE_SEND_DEVICE_UNAVAILABILITY_ALERTS:
			return {
				...state,
				sendDeviceUnavailabilityAlerts: !state.sendDeviceUnavailabilityAlerts,
			};
		case EditRestaurantActionTypes.CHANGE_PAYMENT_TYPE_ID:
			return {
				...state,
				paymentTypeId: action.payload.paymentTypeId,
			};
		case EditRestaurantActionTypes.CHANGE_EXTRA_PAYMENT_TYPE:
			return {
				...state,
				extraPaymentTypes: action.payload.extraPaymentTypes,
			};
		case EditRestaurantActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditRestaurantActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditRestaurantActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				shortName: '',
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				clientType: null,
				fetchedCountries: [],
				IDSelectedCountry: null,
				fetchedCities: [],
				IDSelectedCity: null,
				address: '',
				fetchedCurrencies: [],
				selectedCurrencySymbol: null,
				masterPhoneNumber: '',
				email: '',
				code: '',
				additionalApplications: [],
				vivaWalletIsv: {
					sourceId: '',
					isvSourceId: '',
					isvPercent: null,
					isvFixedFeeAmount: null,
					isvFixedFeeThreshold: null,
					pinCode: '',
					franchiseFeeSupported: false,
					franchisePercent: null,
					franchiseFixedFeeAmount: null,
					franchiseFixedFeeThreshold: null,
				},
				supplier: {
					name: '',
					taxpayerId: '',
					phone: '',
				},
				isOpenPriceServiceCharge: false,
				openPricePercent: null,
				priceType: null,
				isUsedCustomerPriceType: false,
				loyalty: '',
				isUsedCustomerTips: false,
				tips0: null,
				tips1: null,
				tips2: null,
				tips3: null,
				defaultTips: null,
				useKmTariff: false,
				tipsCommissionPercent: null,
				tipsCommissionMaxValue: null,
				isCharityEnabled: false,
				charityName: '',
				charityLogoPath: null,
				charityLogoFileId: null,
				charityAmount0: null,
				charityAmount1: null,
				charityAmount2: null,
				charityAmount3: null,
				defaultCharityAmountIndex: null,
				isShowLoyaltyProgramButtons: false,
				baseMcc: null,
				mainMccCardBrand: null,
				mainMccCardMcc: null,
				mccCards: [],
				useCustomerMcc: false,
				downloadAppAndroidUrl: '',
				downloadAppIosUrl: '',
				fetchedLanguages: [],
				IDDefaultLanguage: null,
				IDsLanguages: [],
				restaurantLanguages: [],
				restrictionQrValue: '',
				usePosPhotos: false,
				enableStopListJob: false,
				useCustomerStopListSyncInterval: true,
				stopListSyncIntervalMinutes: null,
				updateOfTheLauncher: false,
				cardAcceptorId: '',
				cardAcceptorName: '',
				terminalId: '',
				vat: '',
				timeBlockChildAccess: '',
				IDPosSystem: null,
				fileIdForLauncherSettings: null,
				fetchedAcquirers: [],
				useMenuVersion: 'None',
				useContentVersion: 'None',
				customerMenuVersion: '',
				customerContentVersion: '',
				restaurantMenuVersion: '',
				restaurantContentVersion: '',
				generatedWatchCommandsLink: null,
				useTlsCertificate: false,
				tlsCertificateLevel: null,
				tlsCertificateName: null,
				tlsCertificateFilePath: null,
				tlsCertificateFileId: null,
				tlsCertificateFileHash: null,
				vatId: '',
				kmVatId: '',
				bpaSetId: null,
				isActiveBpa: false,
				sendDeviceUnavailabilityAlerts: false,
				paymentTypeId: null,
				extraPaymentTypes: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
